var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.30741 6.30766C6.63657 5.9785 7.17024 5.9785 7.49939 6.30766L11.9605 10.7688L16.4217 6.30766C16.7509 5.9785 17.2845 5.9785 17.6137 6.30766C17.9428 6.63681 17.9428 7.17048 17.6137 7.49964L13.1525 11.9608L17.6137 16.4219C17.9428 16.7511 17.9428 17.2848 17.6137 17.6139C17.2845 17.9431 16.7509 17.9431 16.4217 17.6139L11.9605 13.1528L7.49939 17.6139C7.17024 17.9431 6.63657 17.9431 6.30741 17.6139C5.97826 17.2848 5.97826 16.7511 6.30741 16.4219L10.7686 11.9608L6.30741 7.49964C5.97826 7.17048 5.97826 6.63681 6.30741 6.30766Z",
    fill: "#A197AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ef99687bef5c1e7f9898ba5dd6a2dc44.svg";
export { ForwardRef as ReactComponent };